import { useMemo } from "react";

import { cn } from "@/lib/chillnn/cn";

import { Layout } from "../layout";

type Props = {
	// 横並びにするかどうか
	isCol?: boolean;
	label: string;
	//
	textChildren: React.ReactNode;
};

export const BasicInfoLabelWithTextLayout = ({
	// 基本が縦並びなので default は false
	isCol = false,
	label,
	//
	textChildren,
}: Props) => {
	const LayoutStyle = useMemo(() => {
		/**
		 * 縦並びかどうか
		 */
		const isRow = !isCol;

		return isRow ? "flex-col" : "flex-wrap items-center";
	}, [isCol]);

	return (
		<Layout className={cn("flex gap-x-4 gap-y-0.5", LayoutStyle)}>
			<span className="text-sm">{label}</span>

			<div className="text-base">{textChildren}</div>
		</Layout>
	);
};
